export const ClvrPrscQuantityPickerDefaultMargin = 10
